<template>
    <div class="noticeList">
        <Header title="公告" :show-back="true"/>
        <div class="content">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :offset="10"
                    finished-text="没有更多了"
                    @load="onLoad">
                <van-cell
                        v-for="(item,index) in list" :key="index"
                        class="cell" title-class="cell-title" value-title="cell-value"
                        :title="item.notice_title"
                        :value="item.time"
                        @click="goDetail(item.id)"
                        clickable/>
            </van-list>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        components: {
            Header
        },
        data() {
            return {
                list: [],
                page: 0,
                total: null,
                loading: false,
                finished: false
            };
        },
        methods: {
            getData() {
                this.ajax.post("appapi/index/noticeList", {}).then(res => {
                    if (res.data.code === 1) {
                        console.log("res", res.data);
                        this.list.push(...res.data.data.data);
                        this.total = res.data.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.list.length >= this.total) {
                            console.log("加载完成");
                            this.finished = true;
                        }
                    }
                });
            },
            onLoad() {
                setTimeout(() => {
                    this.getData();
                }, 500);
            },
            goDetail(id) {
                this.$router.push({path: '/announcement', query: {id: id}});
            }
        }
    }
</script>

<style lang="scss">
    .noticeList {
        .content {
            padding: 35px 30px;

            .cell {
                padding: 37px 32px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
                border-radius: 20px;
                margin-bottom: 18px;

                &-title {
                    font-size: 30px;
                    color: #3E3E3E;
                    font-weight: bold;
                }

                &-value {
                    font-size: 24px;
                    color: #999;
                }
            }
        }
    }

</style>
